module.exports = __webpack_public_path__ + "img/scarves.697d025f.png";